import { render, staticRenderFns } from "./RulesByGroup.vue?vue&type=template&id=1f004f4a"
import script from "./RulesByGroup.vue?vue&type=script&lang=js"
export * from "./RulesByGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports